import { render, staticRenderFns } from "./IssueCardActions.vue?vue&type=template&id=fd7df508&scoped=true"
import script from "./IssueCardActions.vue?vue&type=script&lang=js"
export * from "./IssueCardActions.vue?vue&type=script&lang=js"
import style0 from "./IssueCardActions.vue?vue&type=style&index=0&id=fd7df508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7df508",
  null
  
)

export default component.exports